const ITEMS = [
  "Retro Bollywood Classics",
  "70s–80s Golden Era",
  "English Evergreen Ballads",
  "Chandigarh",
  "Mohali",
  "Panchkula",
  "Zirakpur",
  "Kharar",
  "New Chandigarh",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden border-y border-gold/15 bg-navy-900/60 py-4" data-testid="editorial-marquee" aria-hidden="true">
      <div className="flex w-max animate-marquee gap-0">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center whitespace-nowrap font-serif text-lg italic text-gold/80">
                <span className="px-6">{item}</span>
                <span className="text-burgundy-light">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
